module.exports = __webpack_public_path__ + "img/letter-icon-active.66ee4e83.svg";